
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useEffect, useState } from "react"
import { deleteCompanyDoc, getCompanyDocs, updateCompanyDocs } from "../../features/companyProfile/companyProfileSlice"
import Btn from "../../components/shared/button/Btn"
import useWindowDimensions from "../../hooks/useWindowSize"
import SmallSpinner from "../../components/shared/spinners/SmallSpinner"
import { showModal } from "../../features/modal/modalSlice"
import { validateFile } from "../../helper/docs/validateFile"
import ImageUploader from "../../components/docs/ImageUploader"

const Container = styled.div`
    width: 100%;

.wrapper{
  display: flex;
  flex-direction: column;

  .content{
    width: calc(100% - 60px);
    margin: 60px 30px;
    display: flex;
    flex-direction: column;
    height: auto;
    position: relative;

    .doc-list{
      display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 30px;
        width: 100%;
        padding: 20px 0;


        .doc-item{
            width: calc(50% - 15px);
            height: 400px;
            border: 1px solid ${({theme}) => theme.mainTextColor};
            border-radius: 10px;
            overflow: hidden;
            
            .doc-item-top{
                width: 100%;
                height: 50px;
                border: 1px solid ${({theme}) => theme.mainBorderColor};
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);

                .action{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;

                        span{

                            &:first-child{
                                width: 60px;
                            }
                        }


                        .delete-btn{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                            /* background-color: var(--color-main); */
                            color: #fff;
                            color: var(--color-main);
                            border: 1px solid var(--color-main);
                            padding: 5px 7px;
                            border-radius: 5px;
                            cursor: pointer;
                            margin-right: 10px;
                            transition: .2s;

                            &:hover{
                                background-color: var(--color-main);
                                color: #fff;
                            }
                        }
                    }
            }
        }

        .new-select-item{
            border-color: red;
            border-width: 2px;

            .new-select-item-top{
                background-color: #ff000040;
            }
        }
    }

    .bottom-container{
      margin-bottom: -100px;
      width: 100%;
      height: 80px;
      position: sticky;
      bottom: 0;
      z-index: 20;
      border: 1px solid ${({theme}) => theme.mainTextColor};
      background-color: ${({theme}) => theme.mainBgColor};
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 20px;
    }
  }
}

  @media(max-width: 700px){
    .doc-container{
      margin-top: 10px !important;
    }
  }

  @media(max-width: 500px){
    h4{
      font-size: var(--font-size-sm) !important;
      font-weight: var(--font-weight-lg);
    }
  }

`

const FirmaBelgeleri = () => {

    const dispatch = useDispatch()
    const {windowDimensions} = useWindowDimensions()

    const {companyDocs, isLoadingUpdateCompanyDocs} = useSelector(state => state.companyProfile)
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const [fileList, setFileList] = useState([])


    useEffect(()=> {
      setFileList([
        {
            selectedFile: null,
            loadedBefore: companyDocs?.logo1 ? companyDocs.logo1 : null,
            fileTypeName: "Logo-1",
            staticValue: "logo1"
        },
        {
            selectedFile: null,
            loadedBefore: companyDocs?.logo2 ? companyDocs.logo2 : null,
            fileTypeName: "Logo-2",
            staticValue: "logo2"
        },
        {
            selectedFile: null,
            loadedBefore: companyDocs?.vergiLevhasi ? companyDocs.vergiLevhasi : null,
            fileTypeName: "Vergi Levhası",
            staticValue: "vergiLevhasi"
        },
        {
            selectedFile: null,
            loadedBefore: companyDocs?.kase ? companyDocs.kase : null,
            fileTypeName: "Kaşe",
            staticValue: "kase"
        },
        {
            selectedFile: null,
            loadedBefore: companyDocs?.faturaBaslik ? companyDocs.faturaBaslik : null,
            fileTypeName: "Fatura Başlığı",
            staticValue: "faturaBaslik"
        },
        {
            selectedFile: null,
            loadedBefore: companyDocs?.companyOzelPhoto1 ? companyDocs.companyOzelPhoto1 : null,
            fileTypeName: "Firmaya Özel Foto-1",
            staticValue: "companyOzelPhoto1"
        },
        {
            selectedFile: null,
            loadedBefore: companyDocs?.companyOzelPhoto2 ? companyDocs.companyOzelPhoto2 : null,
            fileTypeName: "Firmaya Özel Foto-2",
            staticValue: "companyOzelPhoto2"
        },
        {
          selectedFile: null,
          loadedBefore: companyDocs?.companyOzelPhoto3 ? companyDocs.companyOzelPhoto3 : null,
          fileTypeName: "Firmaya Özel Foto-3",
          staticValue: "companyOzelPhoto3"
      },
    ])

    },[companyDocs])

  const handleRemoveDoc = (fileItem) => {

    dispatch(deleteCompanyDoc(fileItem?.staticValue))

  }

  const handleFileSelect = async(index, files) => {

      const file = await validateFile({file: files[0], maxSize: 5 * 1024 * 1024, allowedTypes:['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']})
    
      if(file){
        // Tüm kontroller başarılıysa, dosyayı fileList'e ekliyoruz
        const newUploads = [...fileList];
        newUploads[index].selectedFile = file;
        setFileList(newUploads);
      };
  }

    useEffect(() => {
      dispatch(getCompanyDocs())
    },[])

    //! logo1
    //! logo2
    //! vergiLevhasi
    //! kase
    //! faturaBaslik
    //! companyOzelPhoto1
    //! companyOzelPhoto2
    //! companyOzelPhoto3

    const handleSubmit = () => {

      const list = fileList.filter(item => item.selectedFile).map(item => {
        return {
          docName: item.staticValue,
          doc: item.selectedFile
        }
      }) 
      
      dispatch(updateCompanyDocs({
        list,
        companyId: JSON.parse(storage.getItem("companyId"))
      }))
    }


  return (
    <Container>
      <div className="wrapper">
        {
          windowDimensions.width > 850 &&
          <PageTopTitle title={"Firma Belgeleri"} position='sticky' top='210px'/>
        }
        <div className="content">
         <div className="doc-list">
         {
                    fileList.map((fileItem, index) => {
                        let previewSrc;
                        let isPdf;
                        if (fileItem.selectedFile) {
                            isPdf = fileItem.selectedFile.type === "application/pdf"
                            previewSrc = URL.createObjectURL(fileItem.selectedFile);

                        } else if (fileItem.loadedBefore) {
                          previewSrc = `${process.env.REACT_APP_API_IMG_COMPANY_URI}${fileItem.loadedBefore}`;
                        } else {
                          previewSrc = "question";
                        }

                        return (
                            <div className={fileItem.selectedFile ? "new-select-item doc-item" : "doc-item"}>
                                 <div className={fileItem.selectedFile ? "new-select-item-top doc-item-top" : "doc-item-top"}>
                                    {fileItem.selectedFile ? (
                                        <p>Yeni Seçilen Belge: {fileItem.selectedFile.name} - ({fileItem.fileTypeName})</p>
                                    ) : fileItem.loadedBefore ? (
                                        <p className="action">
                                            <span></span>
                                            <span>Önceden Yüklenmiş Belge - ({fileItem.fileTypeName})</span>
                                            <button className="delete-btn" onClick={() => handleRemoveDoc(fileItem)}>Belgeyi Sil</button>
                                        </p>
                                    ) : (
                                        <p>Belge Seçilmedi - ({fileItem.fileTypeName})</p>
                                    )}
                                </div>
                                <ImageUploader
                                    previewSrc={previewSrc}
                                    isPdf={isPdf} 
                                    onFileSelect={(files) => handleFileSelect(index, files)} 
                                />
                            </div>
                        )
                    }) 
                }
        </div>

        <div className="bottom-container">
          <Btn handleClick={handleSubmit} width={"220px"} bgColor="#E85446" color="#fff" padding="10px" isDisabled={fileList.filter(item => item.selectedFile).length < 1}>{isLoadingUpdateCompanyDocs ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : fileList.filter(item => item.selectedFile).length < 1 ? "Değişiklik Yok":  `${fileList.filter(item => item.selectedFile).length} Değişiklik Kaydet`}</Btn>
          <Btn handleClick={() => dispatch(showModal(null))} width={"220px"} bgColor="transparent" borderColor="#E85446" color="#E85446" padding="10px">Vazgeç</Btn>
        </div>

        </div>
      </div>
    </Container>
  )
}

export default FirmaBelgeleri
